import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { IConstants, ISession } from '../../../models/pro-sites';
import TextInput from '../../inputs/text-input';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';
import {
    IShippingLabelRequest,
    ShippingLabelErrors,
    LabelRequestDTO,
} from '../../../models/shipping-label';
import './shipping-label.css';
import { matchesNameCode } from '../../../common';
import { loadConstants } from '../../../store/externals/externals-actions';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { FieldValidation, validate } from '../../../validation/validation';
import * as Validators from '../../../validation/validators';
import { IProfile } from '../../../models/profile';
import { loadProfile } from '../../../store/profile/profile-actions';
import { loadSession } from '../../../store/session/session-actions';
import { loadSessionAccount } from '../../../store/account/account-actions';
import { IAccount } from '../../../models/company-account';
import {
    getShippingLabelPDF,
    submitLabelRequest,
} from '../../../api/shipping-label-api';
import SelectInput from '../../inputs/select-input';
import { isMiracleEar } from '../../../hooks/miracle-ear-hook';
import { apiOpenPDF } from '../../../api/api-utils';

interface IPrintShippingLabelProps {
    session: ISession | null;
    constants: IConstants | null;
    loadConstants: () => Promise<void>;
    profile: IProfile | null;
    loadProfile: () => Promise<void>;
    loadSession: () => Promise<void>;
    sessionAccount: IAccount | null;
    loadSessionAccount: () => Promise<void>;
    shippingLabelRequest: IShippingLabelRequest;
}

export const ShippingLabel = ({
    session,
    constants,
    profile,
    sessionAccount,
    loadConstants,
    loadProfile,
    loadSession,
    loadSessionAccount,
    shippingLabelRequest,
}: IPrintShippingLabelProps) => {
    const [errorsState, setErrorsState] = useState({});
    const [shippingLabelRequestState, setShippingLabelRequestState] = useState({
        ...shippingLabelRequest!,
    });
    const [saving, setSaving] = useState(false);
    const [validating, setValidating] = useState(false);
    const [saveError, setSaveError] = useState(false);
    const errors: string[] = [];
    const [shippingServiceErrors, setshippingServiceErrors] = useState(errors);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [sessionAccountData, setSessionAccountData] = useState({
        ...sessionAccount!,
    });
    const [fieldsInitialized, setFieldsInitialized] = useState(false);
    const contactNameRequired = 'Contact Name is required';
    const businessNameRequired = 'Business Name is required';
    const phoneNumberRequired = 'Phone Number is required';
    const addressLine1Required = 'Line1 is required';
    const cityRequired = 'City is required';
    const zipRequired = 'Zip is required';
    const unspecifiedError: any =
        'An unspecified error occurred submitting shipping label Request.';

    // useEffect(() => {
    //     console.log('before loading constants');
    //     if (constants === null) {
    //         loadConstants();
    //         console.log('after loading constants');
    //     }
    // });

    // useEffect(() => {
    //     console.log('before loading profile');
    //     if (profile === undefined) {
    //         loadProfile();
    //         console.log('after loading profile');
    //     }
    // });
    useEffect(() => {
        console.log('before creating request state');
        if (constants === null) {
            loadConstants();
        }
        if (profile === undefined) {
            loadProfile();
        }
        if (sessionAccount === null || sessionAccount === undefined) {
            loadSessionAccount();
        }
        if (
            !fieldsInitialized &&
            constants !== null &&
            profile !== undefined &&
            profile !== null &&
            session !== undefined &&
            session !== null &&
            sessionAccount !== null &&
            sessionAccount !== undefined
        ) {
            setFieldsInitialized(true);
            const nuEarSite = window.location.href.includes('nuearpro');
            const audibelSite = window.location.href.includes('audibelpro');
            const starkeyBusinessName = 'Starkey Hearing Technologies';
            const audibelBusinessName = 'Audibel Hearing Center';
            const nuEarBusinessName = 'NuEar';
            const starkeyPhoneNumber = '952-941-6401';
            const audiblePhoneNumber = '800-769-2590';
            const nuEarPhoneNumber = '800-328-8602';
            let businessName = starkeyBusinessName;
            let phoneNumber = starkeyPhoneNumber;
            if (nuEarSite) {
                businessName = nuEarBusinessName;
                phoneNumber = nuEarPhoneNumber;
            }
            if (audibelSite) {
                businessName = audibelBusinessName;
                phoneNumber = audiblePhoneNumber;
            }
            const line1 = '6700 Washington Ave South';
            const city = 'Eden Prairie';
            const state = 'MN';
            const zipCode = '55344';
            setShippingLabelRequestState({
                contactName: profile!.firstName + ' ' + profile!.lastName,
                businessName: sessionAccount!.partyName,
                phoneNumber: session!.contactInfo!.phone,
                addressLine1: sessionAccount!.street1,
                addressLine2: sessionAccount!.street2,
                city: sessionAccount!.city,
                state: sessionAccount!.state,
                zipCode: sessionAccount!.postalCode,
                country: 'USA',
                serviceTypeCode: '14',
                packagingText: 'Customer Supplied Package',
                weight: '1 lb.',
                isNuEar: window.location.href.includes('nuearpro'),
                rBusinessName: businessName,
                rPhoneNumber: phoneNumber,
                rLine1: line1,
                rCity: city,
                rState: state,
                rZipCode: zipCode,
            });
            console.log('after creating constants');
        }
    });

    const onChange = (event: any) => {
        const { name, value } = event.target;

        const request = update(shippingLabelRequestState, {
            [name]: { $set: value },
        });
        setShippingLabelRequestState(request);
    };

    const fieldValidations = [
        new FieldValidation('businessName', 'Business Name', [
            Validators.required(businessNameRequired),
        ]),
        new FieldValidation('contactName', 'Contact Name', [
            Validators.required(contactNameRequired),
        ]),
        new FieldValidation('phoneNumber', 'Phone Number', [
            Validators.required(phoneNumberRequired),
        ]),
        new FieldValidation('addressLine1', 'Address Line 1', [
            Validators.required(addressLine1Required),
        ]),
        new FieldValidation('city', 'City', [
            Validators.required(cityRequired),
        ]),
        new FieldValidation('zipCode', 'Zip Code', [
            Validators.required(zipRequired),
        ]),
    ];

    const formIsValid = (): boolean => {
        setValidating(true);
        const validations = fieldValidations;

        const errors: ShippingLabelErrors = validate(
            shippingLabelRequestState,
            validations
        );
        setErrorsState(errors);
        return Object.keys(errors).length === 0;
    };

    const formInvalid = () => {
        const errorLength = Object.keys(errorsState).length;
        return errorLength > 0 && !(errorLength === 1 && saveError);
    };

    const save = async () => {
        try {
            setSaving(true);

            const dto: LabelRequestDTO = {
                contactName: shippingLabelRequestState.contactName,
                businessName: shippingLabelRequestState.businessName,
                phoneNumber: shippingLabelRequestState.phoneNumber,
                street1: shippingLabelRequestState.addressLine1,
                street2: shippingLabelRequestState.addressLine2,
                city: shippingLabelRequestState.city,
                state: shippingLabelRequestState.state,
                zipCode: shippingLabelRequestState.zipCode,
                shippingServiceCode: shippingLabelRequestState.serviceTypeCode,
            };

            const result = await submitLabelRequest(dto);
            const pdfFileName = result.data!.Body!.fileName;
            const errors: string[] | undefined = result.data!.Body!.errors;
            if (
                result!.ok &&
                pdfFileName !== null &&
                pdfFileName !== undefined
            ) {
                setValidating(false);
                setSaving(false);
                setFormSubmitted(true);
            } else {
                setSaving(false);
                setSaveError(unspecifiedError);
                setshippingServiceErrors(errors!);
            }

            // eslint-disable-next-line no-useless-concat
            if (pdfFileName !== null && pdfFileName !== undefined) {
                const result = await getShippingLabelPDF(
                    '/services/shippingLabel/form/' + pdfFileName
                );
                apiOpenPDF(result);
            } else {
                //setshippingServiceErrors(['Pdf file is not created']);
                setSaving(false);
                setSaveError(unspecifiedError);
                setshippingServiceErrors(errors!);
            }
        } catch (error) {
            setSaving(false);
            setSaveError(true);
        }
    };

    const handleSave = (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        setValidating(true);
        setshippingServiceErrors([]);
        setSaveError(false);
        if (!formIsValid()) {
            return;
        }

        save();
    };

    const openShippingLabelInstructions = async (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
        e.preventDefault();
        const result = await getShippingLabelPDF(
            '/pdfs/Rechargeable_Shipping_Guide.pdf'
        );
        apiOpenPDF(result);
    };

    return (
        <>
            {session && constants && (
                <>
                    <form onSubmit={handleSave}>
                        <div className="row">
                            <div className="col-sm-9">
                                <h1
                                    className={
                                        shippingLabelRequestState.isNuEar
                                            ? 'nuEar'
                                            : 'starkey'
                                    }
                                >
                                    Printable UPS Labels
                                </h1>

                                <div className="well">
                                    <div
                                        className="form-horizontal"
                                        role="form"
                                    >
                                        <h3 className="gutter-top underline forms">
                                            Shipper Information
                                        </h3>
                                        <div className="form-group">
                                            <TextInput
                                                name="contactName"
                                                label="Contact Name"
                                                labelClassName="control-label col-sm-4"
                                                fieldClassName="col-sm-8 col-md-6"
                                                value={
                                                    shippingLabelRequestState.contactName
                                                }
                                                maxLength={30}
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !shippingLabelRequestState.contactName &&
                                                    validating
                                                        ? contactNameRequired
                                                        : undefined
                                                }
                                            />
                                        </div>
                                        <div className="form-group">
                                            <TextInput
                                                name="businessName"
                                                label="Business Name"
                                                labelClassName="control-label col-sm-4"
                                                fieldClassName="col-sm-8 col-md-6"
                                                value={
                                                    shippingLabelRequestState.businessName
                                                }
                                                maxLength={100}
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !shippingLabelRequestState.businessName &&
                                                    validating
                                                        ? businessNameRequired
                                                        : undefined
                                                }
                                            />
                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <TextInput
                                                    name="phoneNumber"
                                                    label="Phone Number"
                                                    labelClassName="control-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        shippingLabelRequestState.phoneNumber
                                                    }
                                                    maxLength={20}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        !shippingLabelRequestState.phoneNumber &&
                                                        validating
                                                            ? phoneNumberRequired
                                                            : undefined
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <TextInput
                                                    name="addressLine1"
                                                    label="Address Line 1"
                                                    labelClassName="ontrol-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        shippingLabelRequestState.addressLine1
                                                    }
                                                    maxLength={30}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        !shippingLabelRequestState.addressLine1 &&
                                                        validating
                                                            ? addressLine1Required
                                                            : undefined
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <TextInput
                                                    name="addressLine2"
                                                    label="Address Line 2"
                                                    labelClassName="ontrol-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        shippingLabelRequestState.addressLine2
                                                    }
                                                    maxLength={30}
                                                    onChange={onChange}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <TextInput
                                                    name="city"
                                                    label="City"
                                                    labelClassName="ontrol-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        shippingLabelRequestState.city
                                                    }
                                                    maxLength={30}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        !shippingLabelRequestState.city &&
                                                        validating
                                                            ? cityRequired
                                                            : undefined
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div>
                                                <SelectInput
                                                    name="state"
                                                    label="State"
                                                    labelClassName="ontrol-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    options={constants.states.map(
                                                        (st) => ({
                                                            value: st.code,
                                                            text: st.name,
                                                        })
                                                    )}
                                                    value={
                                                        shippingLabelRequestState.state
                                                    }
                                                    hasDefaultOption={false}
                                                    onChange={onChange}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <TextInput
                                                    name="zipCode"
                                                    label="Postal Code"
                                                    labelClassName="ontrol-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        shippingLabelRequestState.zipCode
                                                    }
                                                    maxLength={15}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        !shippingLabelRequestState.zipCode &&
                                                        validating
                                                            ? contactNameRequired
                                                            : undefined
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label col-sm-4">
                                                <FormattedMessage id="Country" />
                                                :
                                            </label>
                                            <div className="col-sm-8">
                                                <p className="form-control-static">
                                                    USA
                                                </p>
                                            </div>
                                        </div>
                                        <h3 className="gutter-top underline forms">
                                            Shipping Service
                                        </h3>
                                        <div className="form-group">
                                            <div>
                                                <SelectInput
                                                    name="serviceTypeCode"
                                                    label="Service Type"
                                                    labelClassName="ontrol-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    options={[
                                                        {
                                                            text: 'Overnight, next day by 10:30',
                                                            value: '14',
                                                        },
                                                        {
                                                            text: 'Ground Shipment',
                                                            value: '03',
                                                        },
                                                    ]}
                                                    value={
                                                        shippingLabelRequestState.serviceTypeCode
                                                    }
                                                    hasDefaultOption={false}
                                                    onChange={onChange}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label col-sm-4">
                                                Packaging
                                            </label>
                                            <div className="col-sm-8 col-md-6">
                                                <p className="form-control-static">
                                                    Customer Supplied Package
                                                </p>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label col-sm-4">
                                                Weight:
                                            </label>
                                            <div className="col-sm-8 col-md-6">
                                                <p className="form-control-static">
                                                    1 lb.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <h3 className="gutter-top underline forms">
                                        Important Note:
                                    </h3>
                                    <p>
                                        In the Adobe Reader &#34;Print&#34;
                                        window, please be sure to set the
                                        &#34;Page Scaling&#34; option to
                                        &#34;None&#34;.
                                    </p>
                                </div>
                                {formInvalid() && (
                                    <div className="alert alert-danger">
                                        <span>
                                            <FormattedMessage id="Please_enter_into_before_submitting" />
                                        </span>
                                    </div>
                                )}
                                {saveError && (
                                    <div className="alert alert-danger">
                                        <strong>
                                            UPS pickup scheduling service
                                            reported the following error(s):
                                        </strong>
                                        <ul className="list">
                                            {shippingServiceErrors.map(
                                                (item) => (
                                                    <li>{item}</li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                )}

                                <div className="gutter-top">
                                    <button
                                        id="save-changes"
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        <span>
                                            {saving ? (
                                                <>{'Generating Label ...'}</>
                                            ) : (
                                                <>{'Create Shipping Label'}</>
                                            )}
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-3 hidden-xs">
                                <div className="shipping">
                                    <span>For instructions on shipping</span>
                                    <br />
                                    <span>
                                        rechargeable products, view our{' '}
                                    </span>
                                    <a
                                        className="pdfLink"
                                        target="_blank"
                                        href="#"
                                        onClick={(e) =>
                                            openShippingLabelInstructions(e)
                                        }
                                    >
                                        Rechargeable Shipping Guide
                                    </a>
                                </div>
                                {!isMiracleEar(session.siteNumber) && (
                                    <div className="gutter-top">
                                        <h3 className="gutter-top underline forms">
                                            Recipient Information
                                        </h3>
                                        <p>
                                            <span>
                                                {
                                                    shippingLabelRequestState.rBusinessName
                                                }
                                            </span>
                                            <br />
                                            <span>
                                                {
                                                    shippingLabelRequestState.rLine1
                                                }
                                            </span>
                                            <br />
                                            <span>
                                                {
                                                    shippingLabelRequestState.rCity
                                                }
                                            </span>
                                            ,
                                            <span>
                                                {
                                                    shippingLabelRequestState.rState
                                                }
                                            </span>{' '}
                                            <span>
                                                {
                                                    shippingLabelRequestState.rZipCode
                                                }
                                            </span>
                                            <br />
                                            USA
                                            <br />
                                        </p>
                                        <p style={{ margin: '15px 0' }}>
                                            {
                                                shippingLabelRequestState.rPhoneNumber
                                            }
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>
                </>
            )}
        </>
    );
};

const mapProfileFromState = (
    profile: IProfile | null,
    session: ISession | null,
    constants: IConstants | null
): IProfile | null => {
    if (!profile || !session || !constants) {
        return profile!;
    }

    const value = profile.country || session.country;
    const found = constants.countries.find(matchesNameCode(value));

    return found && profile.country === found.code
        ? profile
        : { ...profile, country: found ? found.code : undefined };
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
        constants: state.constants,
        profile: mapProfileFromState(
            state.profile ? state.profile.data! : null,
            state.session ? state.session.data! : null,
            state.constants
        ),
        sessionAccount: state.sessionAccount
            ? state.sessionAccount!.data!
            : null,
    };
};

const mapDispatchToProps = {
    loadConstants,
    loadProfile,
    loadSession,
    loadSessionAccount,
};

const shippingLabelRequestContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ShippingLabel);

export default shippingLabelRequestContainer;
